module.exports = __webpack_public_path__ + "img/pbl02_09.8b1f06f5.jpg";